import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatNumber(num) {
  num = Number(num) || 0;
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function getStatusColor(status) {
  switch (status) {
    case 'generating':
      return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
    case 'queued':
      return 'bg-indigo-500/20 text-indigo-300 border-indigo-500/30';
    case 'pending':
      return 'badge-trending';
    case 'approved':
      return 'badge-success';
    case 'rejected':
      return 'badge-viral';
    case 'published':
      return 'badge-success';
    case 'failed':
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    default:
      return 'bg-muted text-muted-foreground';
  }
}
